import {NgModule, Component, Injectable} from '@angular/core';
import {ToasterModule, ToasterService, 
        BodyOutputType, Toast}          from 'angular2-toaster';
import { UserService }                  from './user.service';

@Injectable()
export class ToastService {
    constructor(private toasterService: ToasterService, private user: UserService) {
        this.toasterService = toasterService;
    }

    popToastSuccess(message) {
        this.toasterService.pop('success', 'Success', message);
    }

    setMessage(errors) {
        var msg = "<ul>";
        console.log(errors);
        if(typeof errors == "string") {
            msg += "<li>"+errors+"</li>";
        } else if(errors.error) {
            msg += "<li>"+errors.error+"</li>";
        }else {
            for (var error in errors) {
                var errObject = errors[error];

                for (var property in errObject) {
                    if (errObject.hasOwnProperty(property)) {
                        msg += "<li>"+errors[error][property] + "</li>";
                    }
                }

            }
        }
        
        msg += "</ul>";

        return msg;
    }

    popToastFail(title, errors) {
        var msg = '';
        if(title == "Unauthenticated" || title == "Unauthenticated.") {
            this.user.logout();
        }
        if(errors.length < 1) {
            msg = '';
        } else {
            msg = this.setMessage(errors);
        }
        
        var toast : Toast = {
            type: 'error',
            title: title,
            body: msg,
            bodyOutputType: BodyOutputType.TrustedHtml
        };
        this.toasterService.pop(toast);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/toast.service.ts